import styles from './EmailSignUpModal.module.scss'

import React, { forwardRef, useState } from 'react'

import { createClickedSegmentEvent } from 'Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import useSplitTrackEvent from 'Hooks/useSplitTrackEvent'

import Modal from 'Components/Modal/ModalWithPortal'

import Button from 'Molecules/Button'

import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const EmailSignUpModalContent = ({ ref, sendEmailEvent, sendSmsEvent }) => {
  const [loading, setLoading] = useState(false)

  const viewModel = {
    header: "How's 10 Bucks Sound?",
    subhead: 'Connect with us for deals, install help and $10 off your next order.',
    buttonText: 'Get Connected',
    buttonTextMobile: 'Connect',
  }

  const trackEvent = useSplitTrackEvent('emailSignUpModalButtonClick')

  const buttonClick = (e) => {
    e.preventDefault()
    setLoading(true)
    sendEmailEvent('Started', 'gobal signup modal')
    sendSmsEvent('Started', 'gobal signup modal')
    trackEvent.then(() => {
      window.location.href = '/emailsignup'
    })
  }

  const content = (
    <div className={styles.EmailSignUpModal}>
      <div className={styles.signUpIcon}>
        <Svg icon={'fast_mail'} size={9} brand={'primary'} tone={'normal'} />
      </div>

      <Typography tone={'normal'} font={'bold'} size={1.5} className={styles.signupModalHeader}>
        <span dangerouslySetInnerHTML={{ __html: viewModel.header }} />
      </Typography>
      <Typography tone={'subtle'} font={'regular'} size={1} className={styles.signupModalContent}>
        <span dangerouslySetInnerHTML={{ __html: viewModel.subhead }} />
      </Typography>
      <div className={styles.EmailSignUpButtonContainer}>
        <Button
          className={styles.signupModalButton}
          brand={'secondary'}
          href={'/emailsignup'}
          fill
          isWaiting={loading}
          onClick={buttonClick}
          segmentEvent={createClickedSegmentEvent('EmailSignUp')}
          event={{
            category: 'Email',
            action: 'Clicked Signup',
            label: 'Modal',
          }}
        >
          <Typography className={styles.emailSignupTextDesktop} tone={'contrast'} size={1.25} font={'bold'}>
            {viewModel.buttonText}
          </Typography>
          <Typography className={styles.emailSignupTextMobile} tone={'contrast'} size={1.25} font={'bold'}>
            {viewModel.buttonTextMobile}
          </Typography>
        </Button>
      </div>
    </div>
  )
  return (
    <Modal id={'emailSignupModal'} defaultOpened outsideClick className={styles.emailSignUpModalContainer} ref={ref}>
      {content}
    </Modal>
  )
}
export default forwardRef(EmailSignUpModalContent)
